import CaptchaProvider from './CaptchaProvider';

export default class ReCaptchaProvider extends CaptchaProvider {
    constructor(element, verifyCallback, config = {}) {
        super(element, verifyCallback, config);
        this.sitekey = config.sitekey;
        this.scriptLoaded = false;
        this.slug = null;
        this.chToken = null;
    }

    async initialize(slug, chToken) {
        this.slug = slug;
        this.chToken = chToken;
        
        if (!this.scriptLoaded) {
            await this.injectScripts();
            this.scriptLoaded = true;
        }
    }

    injectScripts() {
        return new Promise((resolve, reject) => {
            // Check if script already loaded
            if (window.grecaptcha && window.grecaptcha.render) {
                this.render();
                resolve();
                return;
            }

            const body = document.getElementsByTagName('body')[0];

            const recaptchaScript = document.createElement('script');
            recaptchaScript.async = true;
            recaptchaScript.src = 'https://www.google.com/recaptcha/api.js?render=explicit';

            recaptchaScript.onload = () => {
                // Use grecaptcha.ready() to ensure API is fully loaded
                window.grecaptcha.ready(() => {
                    // Defer render after browser paint to avoid Vue reactivity conflicts
                    requestAnimationFrame(() => {
                        setTimeout(() => {
                            this.render();
                            resolve();
                        }, 50);
                    });
                });
            };

            recaptchaScript.onerror = () => {
                reject(new Error('Failed to load reCAPTCHA script'));
            };

            body.appendChild(recaptchaScript);
        });
    }

    async render() {
        if (!window.grecaptcha) {
            console.error('reCAPTCHA library not loaded');
            return;
        }

        // Use element ID string - more robust than element reference
        const elementId = 'ch-captcha-form';
        const element = document.getElementById(elementId);

        if (!element) {
            console.error('reCAPTCHA container element not found:', elementId);
            return;
        }

        this.widgetId = window.grecaptcha.render(elementId, {
            'sitekey': this.sitekey,
            'callback': (response) => this.verify(response)
        });
    }

    async reset() {
        // Don't reset if already validated to avoid Google reCAPTCHA timeout errors
        if (this.isValidated) {
            return;
        }
        
        if (window.grecaptcha && this.widgetId !== null) {
            try {
                window.grecaptcha.reset(this.widgetId);
            } catch (error) {
                // Silently catch reset errors which can occur if widget is already reset
                console.debug('reCAPTCHA reset error (safe to ignore):', error);
            }
        }
        
        this.isValidated = false;
        this.token = null;
    }

    destroy() {
        super.destroy();
        if (window.grecaptcha && this.widgetId !== null) {
            window.grecaptcha.reset(this.widgetId);
        }
    }
}